<template>
	<div>
		<el-dialog title="添加新品" :visible.sync="dialogStatus" width="30%" :close-on-click-modal='false' :destroy-on-close='true'
		append-to-body
		:before-close='closeDialog'>
			<el-form ref="form" :model="goodsParams" label-width="70px">
				<el-form-item label="商品名称" prop="title">
					<el-input size="mini" style="width: 200px;" v-model="goodsParams.title"></el-input>
				</el-form-item>
				<el-form-item label="商品品牌" prop="brand">
					<el-input size="mini" style="width: 120px;" v-model="goodsParams.brand"></el-input>
				</el-form-item>
				<el-form-item :label=" '规格'+(index + 1)" v-for="(skuitem,index) in goodsParams.skus" :key='index'>
					<template>
						<el-input style="width: 150px; margin-right: 5px;" size="mini" v-model="skuitem.value"></el-input>
						<el-button size="mini" v-if="index!=0" @click="deletsku(index)">删除</el-button>
					</template>
					<el-button size="mini" type="primary" v-if="index==goodsParams.skus.length-1" @click="addsku">添加</el-button>
				</el-form-item>
				<el-form-item label="入库单位" prop="in_unit">
					<el-input style="width: 120px;" size="mini" v-model="goodsParams.in_unit"></el-input>
				</el-form-item>
				<el-form-item label="商品图片" prop="in_unit">
					<uploadImg :fileLists="goodsFile" @sendImg="getcheckOrderFileList" />
				</el-form-item>
				<el-form-item label="商品描述" prop="in_unit">
					<el-input type="textarea" style="width: 200px;" :rows="2" placeholder="请输入内容" v-model="goodsParams.desc">
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click="submit">提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import uploadImg from './uploadImg.vue'
	import {
		setNewGoods
	} from '@/api/shopPurchaseApi.js'
	export default {
		props: ['dialogStatus', 'isShopPurchase'],
		components: {
			uploadImg
		},
		data() {
			return {
				goodsParams: {
					title: '',
					brand: '',
					category_info: '',
					desc: '',
					in_unit: '',
					imgs: [],
					skus: [{
						value: ''
					}],
					sku: [],
				},
				goodsFile:[],

				company_info: {
					company_id: this.$store.state.userInfo.companyId,
					company_name: this.$store.state.userInfo.companyName,
					shop_id: this.$store.getters.curShopInfo.shop_id,
					shop_name: this.$store.getters.curShopInfo.shop_name
				}
			}
		},
		methods: {
			closeDialog() {
				this.$emit('closeDialog', false)
			},
			deletsku(index) {
				this.goodsParams.skus.splice(index, 1)
			},
			addsku() {
				this.goodsParams.skus.push({
					value: ''
				})
			},
			submit() {
				if (this.isShopPurchase) {
					this.goodsParams['company_info'] = this.company_info;
				}
				this.goodsParams.skus.forEach(item => {
					if (item.value.trim()) {
						this.goodsParams.sku.push(item.value);
					}
				})
				
				if(!this.goodsParams.title){
					this.$message('请至少输入商品名称');
				}else{
					setNewGoods(this.goodsParams).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.goodsParams={
									title: '',
									brand: '',
									category_info: '',
									desc: '',
									in_unit: '',
									imgs: [],
									skus: [{
										value: ''
									}],
									sku: [],
							}
							this.goodsFile =[];
							this.$emit('closeDialog', false)
						}
					})
				}
				
			},
			getcheckOrderFileList(data) {
				this.goodsParams.imgs = [];
				data.forEach(item=>{
				this.goodsParams.imgs.push(item.url)	
				})
				
			},
		},
		created() {
			console.log();
		},
		destroyed() {
			
			console.log('组件销毁')
		}
	}
</script>

<style lang="scss" scoped="scoped">
</style>
